<template>
  <div class="div">
   <iframe src="/v2/index.html" frameborder="0"></iframe>
  </div>
 </template>
<script>
export default {
  data() {
   return {};
  },
  props: {},
  components: {},
  methods: {},
  mounted() {},
  created() {},
  computed: {},
  watch: {},
};
</script>
<style lang='scss' scoped>
  .div{
    height: 100%;
    height: 100%;
  }
iframe{
  width: 100%;
  height: 100%;
}
</style>